import {
  EntityList,
  EntityListProps,
  renderDate,
  renderEnum,
  renderMultiPersonas,
  renderStatusIcon,
} from 'components/EntityList'
import { Proving } from 'gql.generated'
import {
  ConstrainMode,
  PersonaSize,
  SelectionMode,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type BookingsManagerListProps = EntityListProps<any>

export const BookingsManagerList: React.FunctionComponent<
  BookingsManagerListProps
> = ({ items, ...props }) => {
  const { t } = useTranslation()

  const fieldColumn = createFieldColumn(t)
  const columns = [
    fieldColumn('status', {
      onRender: renderStatusIcon,
      getGroupValue: (item: any) => {
        return item.provingGround ? item.provingGround.title : ''
      },
      ungroupable: true,
      minWidth: 120,
    }),
    fieldColumn('dateFrom', {
      onRender: renderDate,
      isSorted: true,

      ungroupable: true,
    }),
    fieldColumn('dateTo', {
      onRender: renderDate,
      ungroupable: true,
    }),

    fieldColumn('id', {
      ungroupable: true,
    }),
    fieldColumn('title', {
      ungroupable: true,
      minWidth: 120,
    }),
    fieldColumn('provingGround.title', {
      onRender: (item, i, col) => {
        return `${item.provingGround!.title}, ${
          item.provingGround!.countryCode
        }`
      },
      ungroupable: true,
      isGrouped: true,
      getGroupValue: (item: Proving) =>
        `${item.provingGround!.title}, ${item.provingGround!.countryCode}`,
    }),
    fieldColumn('responsible', {
      onRender: (item: any, i, col) => {
        if (item.responsible) {
          return renderMultiPersonas({
            size: PersonaSize.size24,
          })(item, i, col)
        }
      },
      minWidth: 155,
      ungroupable: true,
    }),
    fieldColumn('department', {
      ungroupable: true,
      minWidth: 120,
    }),
    fieldColumn('status', {
      onRender: renderEnum(t, 'status'),
      minWidth: 120,
    }),
  ]

  return (
    <>
      <EntityList
        alternate={true}
        stickyHeader={true}
        selectionMode={SelectionMode.multiple}
        items={items}
        constrainMode={ConstrainMode.horizontalConstrained}
        columns={columns}
        readonly={true}
        {...props}
      />
    </>
  )
}
